module.exports = __webpack_public_path__ + "static/img/stone.8d627b93.png";